import { createAction } from '@ngrx/store';

export const startDownload = createAction('[Download] Start');
export const endDownload = createAction('[Download] End');
